export const EMPLOYEE_COUNT_OPTIONS = ['1-10', '11-50', '51-200', '201-500', '500+'];

export const BUSINESS_TYPE_OPTIONS = [
  'Landscaping',
  'Construction',
  'Plumbing',
  'Electrical',
  'HVAC',
  'Cleaning Services',
  'Security Services',
  'IT Services',
  'Consulting',
  'Engineering',
  'Architecture',
  'Transportation',
  'Food Services',
  'Professional Services',
  'Other',
];
